import { render, staticRenderFns } from "./serviceorders.vue?vue&type=template&id=204b54b6&"
import script from "./serviceorders.vue?vue&type=script&lang=js&"
export * from "./serviceorders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports